<template>
	<div class="basis-page-cls" v-loading="loading">
		<section class="basis-cls_filter" style="border-bottom: none;">
			<span class="label-cls">时间：</span>
			<el-select v-model="listQuery.dateType" @change="getList" size="mini" class="a">
				<el-option
					v-for="item in [
						{id: 'date', name: '天'},
						{id: 'week', name: '周'},
						{id: 'month', name: '月'}
					]"
					:key="item.id"
					:label="item.name"
					:value="item.id">
				</el-option>
			</el-select>
			<el-date-picker
				v-model="listQuery.date"
				:type="listQuery.dateType"
				placeholder="选择日期" 
				size="mini"
				:picker-options="{firstDayOfWeek: 1}"
				:format="listQuery.dateType === 'week' ? 'yyyy 第 WW 周' : ''"
				@change="getList">
			</el-date-picker>
			<el-divider direction="vertical"></el-divider>
			<span class="label-cls">类型：</span>
			<el-radio-group v-model="listQuery.type" size="mini" @change="getList">
				<el-radio-button v-for="(item, index) in [{id: '', name: '全部'}, {id: '1', name: '知识'}, {id: '2', name: '流程'}]" :key="index" :label="item.id">{{item.name}}</el-radio-button>
			</el-radio-group>
			<el-divider direction="vertical"></el-divider>
			<span class="label-cls">资源库：</span>
			<el-select v-model="listQuery.resourceId" @change="getList" size="mini" placeholder="全部">
				<el-option
					v-for="item in resourceList"
					:key="item.id"
					:label="item.name"
					:value="item.id">
				</el-option>
			</el-select>
			<!-- <el-button @click.stop="handleExport" size="mini" style="float: right">导出</el-button> -->
		</section>
		<section class="basis-cls_table">
			<div class="table">
				<table-pagination
					pagination
					:data="list"
					:column="column"
					:total="total"
					:page.sync="listQuery.pageNum"
					:limit.sync="listQuery.pageSize"
					@sort-change="formatterFun"
					@pagination="getList" />
			</div>
		</section>
		<el-drawer
			size="60%"
			:modal="false"
			:modal-append-to-body="false"
			:withHeader="false"
			:visible.sync="drawerKnowledge">
			<KnowInfo v-if="drawerKnowledge" sourceType="Report" :qaId="qaId" @drawerKnowInfoClose="drawerKnowledge = false;" />
		</el-drawer>
	</div>
</template>

<script>
import KnowInfo from '../components/KnowInfo';
export default {
	components: {KnowInfo},
	watch: {
		'listQuery.type': {
			handler(val){
				this.listQuery.resourceId = '';
				this.getResourceList();
			},
			immediate: true,
			deep: true
		}
	},
	data() {
		const formatDate = Vue.filter('formatDate');
		return {
			column: [
				{
                    label: '序号',
                    width: 50,
					align: 'center',
                    render: (h, scope) => {
                        return <span>{((this.listQuery.pageNum - 1) * this.listQuery.pageSize) + (scope.$index + 1)}</span>
                    }
                },
				{ 
					label: '标题', 
					minWidth: 180,
					render: (h, scope) => {
                        return <el-link onClick={() => this.handleView(scope.row)} type="primary">{scope.row.q}</el-link>
                    } 
				},
				{ 
					label: '类型', 
					width: 100,
					render: (h, scope) => {
                        return <el-tag size="mini" type={scope.row.type == '1' ? 'warning' : ''}>{scope.row.type == '1' ? '知识' : '流程'}</el-tag>
                    } 
				},
				{ label: '资源库', prop: 'resourceName' },
				{ 
					label: '分类', 
					minWidth: 180,
					render: (h, scope) => {
                        return <span>{scope.row.nodeNames.replace(/[,]/g, " / ")}</span>
                    } 
				},
				{ 
					label: '创建时间', 
					prop: 'createTime', 
					minWidth: 180,
					sortable: 'custom',
					render: (h, scope) => {
                        return <span>{formatDate(scope.row.createTime)}</span>
                    } 
				},
				{ 
					label: '更新时间',
					prop: 'lastUpdateTime', 
					minWidth: 180,
					sortable: 'custom',
					render: (h, scope) => {
                        return <span>{formatDate(scope.row.lastUpdateTime)}</span>
                    } 
				},
				{ label: '有帮助', prop: 'help', width: 100, align: 'center', sortable: 'custom' },
				{ label: '无帮助', prop: 'noHelp', width: 100, align: 'center', sortable: 'custom' },
				{ label: '查看量', prop: 'num', width: 100, align: 'center', sortable: 'custom' }
            ],
			listQuery: {
				pageNum: 1,
				pageSize: 10,
				projectId: '',
				resourceId: '',
				type:'',
				dateType: 'month',
				date: new Date(),
				start_date: '',
				end_date: '',
				pageOrder: '',
				pageSort: ''
			},
			total: 0,
			list: [],
			loading: false,
			drawerKnowledge: false,
			qaId: '',
			resourceList: []
		}
	},
	async created() {
		await this.getList();
		await this.getResourceList();
	},
	methods: {
		getList() {
			this.loading = true;
			this.listQuery.projectId = this.$store.getters.userInfo.brandIdentify;
			this.$api.apiPostKnowledgeQaClickList(this.listQuery).then(response => {
				if(response.errcode != 0) {
					this.loading = false;
					return;
				}
				this.list = response.data?.rows ? response.data?.rows : [];
				this.total = response.data?.total ? response.data?.total : 0;
				this.loading = false;
			});
		},
		formatterFun(row) {
			this.listQuery.pageOrder = row.prop;
			this.listQuery.pageSort = row.order == 'descending' ? 'desc' : row.order == 'ascending' ? 'asc' : '';
			this.getList();
		},
		handleView(row) {
			this.qaId = row.qaId;
			this.drawerKnowledge = true;
		},
		getResourceList() {
			this.resourceList = [];
			this.$api.apiPostKnowledgeResourceJWTByList({right: 6}).then(response => {
				if(response.errcode != 0) return;
				if(this.listQuery.type == '') {
					this.resourceList = response.data || [];
				} else {
					for(const item of response.data) {
						if(this.listQuery.type == item.type) {
							this.resourceList.push(item);
						}
					}
				}
			});
		}
	}
}
</script>

<style lang="scss" scoped>
.basis-cls_filter {
	::v-deep .el-select.a input {
		width: 60px;
		background: #f5f7fa;
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
		border-right: none;
	}

	::v-deep .el-date-editor input {
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
	}

	.label-cls {
		font-size: 14px;
		color: #838A9D;
	}
}

</style>